import { DenthubSetting } from 'models/denthub-settings';
import { createContext, useContext } from 'react';

type AppSettingsContextValue = {
    appSettings: DenthubSetting;
    setAppSettings: (settings: DenthubSetting) => void;
};

const AppSettingsContext = createContext<AppSettingsContextValue>({
    appSettings: {} as DenthubSetting,
    setAppSettings: () => undefined,
});

export const AppSettingsProvider = AppSettingsContext.Provider;

export const useAppSettings = () => {
    const context = useContext(AppSettingsContext);
    if (!context) throw new Error('useAppSettings must be used within AppSettingsProvider');
    return context;
};
